export default () => ({
  authClinicalService: null,
  requests: [],
  accessTypes: {
    READ: 1,
    WRITE: 2,
    ADMIN: 3,
  },
  authClinicalInfoTypes: {
    PEOPLE: 100,
    PEOPLE_CLINICAL_DETAILS: 150,
    APPOINTMENTS: 200,
    APPOINTMENT_DETAILS: 300,
    DISPENSER_STATISTICS: 500,
    AUDIOLOGIST_STATISTICS: 600
  },
  evocallInfoTypes: {
    REQUESTS: 100,
    REQUEST_DETAILS: 200,
    REQUEST_PRIORITY: 300,
    REQUESTS_HISTORY: 400,
    ONLINE_USERS: 500
  },
  priorities: {
    1: {
      name: 'low',
      color: '#29c4aa',
      iconClass: 'fa fa-angle-down',
    },
    2: {
      name: 'medium',
      color: '#c49d29',
      iconClass: 'fa fa-minus',
    },
    3: {
      name: 'high',
      color: '#c42940',
      iconClass: 'fa fa-angle-up',
    }
  },
  metrics: {
    averageWaitingTime: 0,
    averageCallDuration: 0,
    ongoingCalls: 0
  },
  requestCancelationReasons: {
    REQUESTED_BY_MISTAKE: {
      id: 1,
      name: 'Requested by mistake'
    },
    CERUMEN: {
      id: 2,
      name: 'Cerumen'
    },
    HIGH_ESTIMATED_WAITING_TIME: {
      id: 3,
      name: 'High estimated waiting time'
    },
    NO_INTERNET_CONNECTION: {
      id: 4,
      name: 'No internet connection'
    },
    OTHER_TECHNICAL_DIFFICULTIES: {
      id: 5,
      name: 'Other technical difficulties'
    },
    CLIENT_GAVE_UP: {
      id: 6,
      name: 'Client gave up'
    }
  },
  onlineAudiologistsByEntity: [],
  pendingRequest: null,
  activeRequest: null,
  activeRequestHasUnsavedPersonChanges: false,
  activeRequestHasUnsavedAppointmentChanges: false,
  activeAppointments: [],
  currentActiveAppointment: null,
  activeBreak: null,
  minimizedCallCollapsed: false,
  isLoading: false
})
